// Closing a dialog returns focus to the element that opened it. The browser then scrolls that
// element into view, so the page jumped a little after every dialog. Focus now returns without
// scrolling, and the page is put back where it was when the first dialog opened.
import { BModal } from 'bootstrap-vue';

function scrolledElements() {
  const elements = [document.scrollingElement || document.documentElement];
  document.querySelectorAll('body *').forEach(element => {
    if (element.scrollTop > 0 || element.scrollLeft > 0) {
      elements.push(element);
    }
  });
  return elements.map(element => ({ element: element, top: element.scrollTop, left: element.scrollLeft }));
}

function restore(positions) {
  positions.forEach(position => {
    if (position.element.isConnected && (position.element.scrollTop !== position.top || position.element.scrollLeft !== position.left)) {
      position.element.scrollTop = position.top;
      position.element.scrollLeft = position.left;
    }
  });
}

export function installModalScrollGuard(root) {
  BModal.options.methods.returnFocusTo = function() {
    let element = this.returnFocus || this.return_focus || null;
    element = typeof element === 'string' ? document.querySelector(element) : element;
    element = element && element.$el ? element.$el : element;
    if (element && element.focus && element.offsetParent !== null) {
      try {
        element.focus({ preventScroll: true });
      } catch (e) {
        element.focus();
      }
    }
  };

  let saved = null;
  let open = 0;
  root.$on('bv::modal::show', () => {
    if (open === 0) {
      saved = scrolledElements();
    }
    open++;
  });
  root.$on('bv::modal::hidden', () => {
    open = Math.max(0, open - 1);
    if (open === 0 && saved) {
      const positions = saved;
      saved = null;
      restore(positions);
      window.requestAnimationFrame(() => restore(positions));
    }
  });
}
